/* tslint:disable */

declare var Object: any;
export interface TtadondutyrequestInterface {
  "requestNo": string;
  "companyId": number;
  "requestedby"?: string;
  "requestfor"?: string;
  "requestdate"?: Date;
  "purposeCode": string;
  "totalDestination": number;
  "remark"?: string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "cancelsts"?: string;
  "ondutyStartdate": Date;
  "ondutyEnddate": Date;
  tcltrequests?: any;
  ttamondutypurposetypes?: any;
  teomemppersonals?: any;
  ttadondutyrequestdtls?: any[];
  ttadondutydeclarations?: any;
  ttadondutycancelrequests?: any;
}

export class Ttadondutyrequest implements TtadondutyrequestInterface {
  "requestNo": string;
  "companyId": number;
  "requestedby": string;
  "requestfor": string;
  "requestdate": Date;
  "purposeCode": string;
  "totalDestination": number;
  "remark": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "cancelsts": string;
  "ondutyStartdate": Date;
  "ondutyEnddate": Date;
  tcltrequests: any;
  ttamondutypurposetypes: any;
  teomemppersonals: any;
  ttadondutyrequestdtls: any[];
  ttadondutydeclarations: any;
  ttadondutycancelrequests: any;
  constructor(data?: TtadondutyrequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadondutyrequest`.
   */
  public static getModelName() {
    return "Ttadondutyrequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadondutyrequest for dynamic purposes.
  **/
  public static factory(data: TtadondutyrequestInterface): Ttadondutyrequest{
    return new Ttadondutyrequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadondutyrequest',
      plural: 'Ttadondutyrequests',
      path: 'Ttadondutyrequests',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "requestedby": {
          name: 'requestedby',
          type: 'string'
        },
        "requestfor": {
          name: 'requestfor',
          type: 'string'
        },
        "requestdate": {
          name: 'requestdate',
          type: 'Date'
        },
        "purposeCode": {
          name: 'purposeCode',
          type: 'string'
        },
        "totalDestination": {
          name: 'totalDestination',
          type: 'number'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "cancelsts": {
          name: 'cancelsts',
          type: 'string'
        },
        "ondutyStartdate": {
          name: 'ondutyStartdate',
          type: 'Date'
        },
        "ondutyEnddate": {
          name: 'ondutyEnddate',
          type: 'Date'
        },
      },
      relations: {
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
        ttamondutypurposetypes: {
          name: 'ttamondutypurposetypes',
          type: 'any',
          model: ''
        },
        teomemppersonals: {
          name: 'teomemppersonals',
          type: 'any',
          model: ''
        },
        ttadondutyrequestdtls: {
          name: 'ttadondutyrequestdtls',
          type: 'any[]',
          model: ''
        },
        ttadondutydeclarations: {
          name: 'ttadondutydeclarations',
          type: 'any',
          model: ''
        },
        ttadondutycancelrequests: {
          name: 'ttadondutycancelrequests',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadondutyrequest.ts